import React, { Component } from 'react';
import './questions.css';
import { Form, Input, Select, Button, Modal } from 'antd';

import daydreamImage from "../static/daydream-image.png";

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Translate from "../translate/Translate"
import { translationResultGet } from "../../modules/translate";

import {
	dreamSubmit
} from '../../modules/questions';

class DreamForm extends Component {
	constructor(props) {
		super(props);
		this.state = {
			placeholder1: "",
			placeholder2: "",
			loading: false,
		}
	}

	componentWillMount() {
		translationResultGet("dream.placeholder1").then(
			(titleTranslation) => {
				console.log(titleTranslation[this.props.language])
				this.setState({ placeholder1: titleTranslation[this.props.language] })
			}
		)
		translationResultGet("dream.placeholder2").then(
			(titleTranslation) => {
				console.log(titleTranslation[this.props.language])
				this.setState({ placeholder2: titleTranslation[this.props.language] })
			}
		)
	}

	actFormSubmit = form => {
		var empty = 0
		form.occupations.forEach(element => {
			if (element === undefined || element.length === 0) {
				element = ""
				empty++;
			}
		})
		console.log("Empty occupations: " + empty)
		if (empty > 0) {

			if (this.props.language === "tc") {
				Modal.confirm({
					title: '提示',
					content: '還有空格未填寫，你會再想一想你的夢想職業嗎? ',
					zIndex: 2000,
					cancelText: '我再想一想',
					onCancel: () => {
					},
					okText: '我已想清楚',
					onOk: () => {
						this.setState({ loading: true });
						const filtered = {
							occupations: form.occupations.filter(function (e) { return e })
						};
						// console.log(filtered);
						this.props.dreamSubmit(filtered).then(
							(res) => {
								if (res) {
									// console.log("success")
									this.setState({ loading: false, errormessage: null });
									this.props.formSubmit();
								} else {

									this.setState({ loading: false, errormessage: "Something wrong happened, please try again later." });
								}
							},
							(err) => {
								// console.log("error")
								this.setState({ loading: false, errormessage: "Something wrong happened, please try again later." });
								// this.formRef.current.resetFields();
							}
						);
					},
				});
			} else if (this.props.language === "sc") {
				Modal.confirm({
					title: '提示',
					content: '你确定由细到大都没有考虑过做任何的职业?',
					zIndex: 2000,
					cancelText: '确定',
					onCancel: () => {
						this.setState({ loading: true });
						const filtered = {
							occupations: form.occupations.filter(function (e) { return e })
						};
						// console.log(filtered);
						this.props.dreamSubmit(filtered).then(
							(res) => {
								if (res) {
									// console.log("success")
									this.setState({ loading: false, errormessage: null });
									this.props.formSubmit();
								} else {

									this.setState({ loading: false, errormessage: "Something wrong happened, please try again later." });
								}
							},
							(err) => {
								// console.log("error")
								this.setState({ loading: false, errormessage: "Something wrong happened, please try again later." });
								// this.formRef.current.resetFields();
							}
						);
					},
					okText: '我再想一想',
					onOk: () => { },

				});
			} else if (this.props.language === "en") {
				Modal.confirm({
					title: 'Reminder',
					content: 'Are you sure you haven’t considered doing any career from the finest to most?',
					zIndex: 2000,
					cancelText: 'Confirm',
					onCancel: () => {
						this.setState({ loading: true });
						const filtered = {
							occupations: form.occupations.filter(function (e) { return e })
						};
						// console.log(filtered);
						this.props.dreamSubmit(filtered).then(
							(res) => {
								if (res) {
									// console.log("success")
									this.setState({ loading: false, errormessage: null });
									this.props.formSubmit();
								} else {

									this.setState({ loading: false, errormessage: "Something wrong happened, please try again later." });
								}
							},
							(err) => {
								// console.log("error")
								this.setState({ loading: false, errormessage: "Something wrong happened, please try again later." });
								// this.formRef.current.resetFields();
							}
						);
					},
					okText: 'Let Me Think Again',
					onOk: () => { },

				});
			}
		} else {
			this.setState({ loading: true });
			const filtered = {
				occupations: form.occupations.filter(function (e) { return e })
			};
			// console.log(filtered);
			this.props.dreamSubmit(filtered).then(
				(res) => {
					if (res) {
						// console.log("success")
						this.setState({ loading: false, errormessage: null });
						this.props.formSubmit();
					} else {

						this.setState({ loading: false, errormessage: "Something wrong happened, please try again later." });
					}
				},
				(err) => {
					// console.log("error")
					this.setState({ loading: false, errormessage: "Something wrong happened, please try again later." });
					// this.formRef.current.resetFields();
				}
			);
		}

	}



	render() {


		const { dreamData } = this.state;

		return (
			<div className="formContainer">
				<div className="questionImageContainer dreamBgColor">
					<img src={daydreamImage} className="questionImage"></img>
					<h1><Translate id="dream.title" /></h1>
				</div>
				<div className="questionFormContainer">
					<Form onFinish={this.actFormSubmit} name="dreamForm" layout="horizontal" requiredMark={false}>
						<div className="form lightFont">
							<div>
								<Translate id="dream.intro" />

							</div>

							{/* <Form.Item
								> */}
							{/* <Input.Group> */}
							{[...Array(6)].map((x, i) =>
								<div key={i}>
									{/* <span className="lightFont"></span> */}
									{/* /* <div key={i} className="formItem2"></div> */}
									<Form.Item placeholder=" " name={['occupations', i]} label={`${i + 1} `}
										className="dreamFormItem "
										rules={[
											{
												required: (i < 0) ? true : false,
												message: "Field is required!"
											}
										]} >
										<Input className="longItem dreamInput" placeholder={(`${i} ` == 0 && `${this.state.placeholder1}`) || (`${i} ` == 5 && `${this.state.placeholder2}`)} />

									</Form.Item>
								</div>

							)}
							{/* </Input.Group> */}
							{/* </Form.Item> */}



							{/* <div className="dreamDescription">
								{dreamData[this.props.language]["description"]}
							</div> */}
							<div className="submitBtnContainer2">
								<Button htmlType="submit" type="primary" className="questionsSubmitBtn"><Translate id="questions.next" /></Button>
							</div>
						</div>
					</Form>
				</div>
			</div>
		)
	}

}

const mapStateToProps = state => ({
	language: state.mainpage.language
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			dreamSubmit
		},
		dispatch
	);

//mapStateToProps should be passed as the 1st argument to connect
export default connect(mapStateToProps, mapDispatchToProps)(DreamForm);